import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Select,
  Upload,
  Button,
  Row,
  Col,
  message,
  Card,
  Modal,
  DatePicker,
  InputNumber,
  Radio,
  Checkbox,
} from "antd";
import * as XLSX from "xlsx";
import { PlusOutlined } from "@ant-design/icons";
import { ArrowUpFromLine, Trash2, Users } from "lucide-react";
import { useLocation, useNavigate } from "react-router";
import { Severty, ShowToast } from "../../helper/toast";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import useRequest from "../../hooks/useRequest";
import moment from "moment";
import { validEmail } from "../../helper/functions";
import countries from "../CountryData/countries.json";
const { Option } = Select;

const SetupSurveyForm = () => {
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { request } = useRequest();
  const location = useLocation();
  const [distributionType, setDistributionType] = useState("Platform");
  const [teamSize, setTeamSize] = useState(0);
  const [surveyLink, setSurveyLink] = useState("");
  const [surveyId, setSurveyId] = useState(null);
  const [value, setValue] = useState("");
  const [reConfirmModal, setReConfirmModal] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const members = params.get("members");
    const id = params.get("surveyId");

    if (members) {
      form.setFieldsValue({
        teamSize: Number(members),
      });
    }
    if (id) {
      setSurveyId(id);
      fetchSurveyData(id);
    }
  }, [location]);

  const onFinish = async (values) => {
    try {
      setLoading(true);

      const payload = {
        surveyType: "Team",
        teamName: values.teamName,
        language: values.language,
        teamSize: values.teamSize,
        members: values.members || [],
        country: values.country,
        industry: values.industry,
        teamRole: values.teamRole,
        businessUnit: values.businessUnit,
        paymentType: "Credit",
        companySize: values.companySize,
        openQuestions: [
          values.question1,
          values.question2,
          values.question3,
          values.question4,
        ].filter(Boolean),
        deadline: values.deadline,
        emailTemplate: values.draft,
        distributionMethod: distributionType,
        gdprConsent: values.gdprConsent,
        status: "Open",
      };

      if (payload?.members?.length != teamSize && teamSize <= 12)
        return ShowToast("Team size and team members must be equal!", "error");

      if (payload.distributionMethod === "Platform") {
        // setReConfirmModal(true);
        const inValidMembers = payload.members?.filter(
          (mem) => !mem?.name || !validEmail(mem?.email)
        );
        if (inValidMembers?.length > 0)
          return ShowToast(
            "Please enter name and valid email of each member!",
            "error"
          );
      } else {
        const inValidMembers = payload.members?.filter((mem) => !mem?.name);
        if (inValidMembers?.length > 0)
          return ShowToast("Please enter name of each member!", "error");
      }

      console.log("Submitting payload:", surveyId, payload);
      const config = {
        url: surveyId
          ? `/admin/team/survey/update/${surveyId}`
          : "/admin/team/survey/create",
        method: surveyId ? "PUT" : "POST",
        data: payload,
      };

      request({
        url: config.url,
        data: payload,
        method: config.method,
        onSuccess: (data) => {
          console.log(data, "data here");
          ShowToast(
            data?.message || "Survey created successfully!",
            Severty.SUCCESS
          );
          setIsModalVisible(true);
          setSurveyLink(data?.data?.surveyLink || "");
          setIsModalVisible(true);
          setLoading(false);
        },
        onError: (error) => {
          console.log(error, "error onErorr");
          ShowToast(
            error.response?.data?.message || "Failed to Create Survey",
            Severty.ERROR
          );
          setLoading(false);
        },
      });
    } catch (err) {
      console.error(err, "here error");
      message.error(err.response?.data?.message || "Survey creation failed");
    }
  };

  const fetchSurveyData = async (id) => {
    setLoading(true);
    try {
      request({
        url: `/admin/team/survey/getSurvey/${id}`,
        method: "GET",
        onSuccess: (data) => {
          const surveyData = data;

          if (surveyData?.deadline) {
            surveyData.deadline = moment(surveyData?.deadline);
          }

          surveyData.members = Array.isArray(surveyData.members)
            ? surveyData.members
            : [];

          surveyData.openQuestions = Array.isArray(surveyData.openQuestions)
            ? surveyData.openQuestions
            : [];

          form.setFieldsValue({
            ...surveyData,
            // openQuestions: surveyData.openQuestions,
          });
          setTeamSize(surveyData?.teamSize);
          setDistributionType(surveyData?.distributionMethod || "Platform");
        },
        onError: (error) => {
          ShowToast(
            error.response?.data?.message || "Failed to Fetch Survey",
            Severty.ERROR
          );
          setLoading(false);
        },
      });
    } catch (err) {
      ShowToast(
        err.response?.data?.message || "Failed to load survey data",
        Severty.ERROR
      );
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleModalCloseAndNavigate = () => {
    setIsModalVisible(false);
    navigate("/tq-team-servey");
    form.resetFields();
  };

  const handleCopyLink = async () => {
    if (!surveyLink) {
      message.error("No survey link available!");
      return;
    }
    try {
      await navigator.clipboard.writeText(surveyLink);
      message.success("Survey link copied!");
    } catch (err) {
      message.error("Failed to copy link.");
    }
  };

  const handleDownloadLink = () => {
    if (!surveyLink) {
      message.error("No survey link available!");
      return;
    }
    const element = document.createElement("a");
    const file = new Blob([surveyLink], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "tps-survey-link.txt";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <div className="purchase-survey-cards-main">
      <Card className="purchase-survey-cards">
        <div className="purchase-survey-cards-header-main mb-3">
          <h4 className="purchase-survey-cards-header">
            <Users /> Setup TPS for Teams Survey
          </h4>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{ tags: ["emailDisplay"] }}
        >
          <Row gutter={16}>
            <Col span={24} md={12}>
              <Form.Item
                label="Language for survey and report"
                name="language"
                rules={[{ required: true, message: "Please Select Language" }]}
              >
                {/* <Input placeholder="Language for survey and report" /> */}
                <Select placeholder="Select language">
                  <Option value="en">English</Option>
                  <Option value="fr">French</Option>
                  <Option value="de">German</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={24} md={12}>
              <Form.Item
                label="Team Name"
                name="teamName"
                normalize={(val) => val.trimStart()}
                rules={[{ required: true, message: "Please Enter Team Name" }]}
              >
                <Input placeholder="Enter unique team name" />
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <Form.Item
                label="Number of team members (including team leader)"
                name="teamSize"
                rules={[
                  {
                    validator: (_, val) => {
                      if (!val) {
                        return Promise.reject("Please enter the team size");
                      }
                      if (val < 3) {
                        return Promise.reject(
                          "The team must have at least 3 members"
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputNumber value={teamSize} onChange={setTeamSize} />
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <Form.Item
                label="Country"
                name="country"
                rules={[{ required: true, message: "Please Select Country" }]}
              >
                <Select
                  placeholder="Select country"
                  showSearch
                  optionFilterProp="children"
                >
                  {countries.map((country) => (
                    <Option key={country} value={country}>
                      {country}
                    </Option>
                  ))}
                </Select>
                {/* <Select placeholder="Select country">
                  <Option value="india">India</Option>
                  <Option value="usa">USA</Option>
                  <Option value="uk">UK</Option>
                </Select> */}
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <Form.Item label="Industry" name="industry">
                <Select placeholder="Select industry">
                  {industries.map((ind) => (
                    <Option key={ind} value={ind}>
                      {ind}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={24} md={12}>
              <Form.Item label="Team Role" name="teamRole">
                <Select placeholder="Select team role">
                  {roles.map((role) => (
                    <Option key={role} value={role}>
                      {role}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <Form.Item label="Business Unit" name="businessUnit">
                <Select placeholder="Select business unit">
                  <Option value="unit1">Unit 1</Option>
                  <Option value="unit2">Unit 2</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={24} md={12}>
              <Form.Item label="Company Size" name="companySize">
                <Select placeholder="Select company size">
                  <Option value="small">1-50</Option>
                  <Option value="medium">51-200</Option>
                  <Option value="large">201+</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Col span={24}>
            <Form.Item label="Survey Distribution Method">
              <Radio.Group
                onChange={(e) => setDistributionType(e.target.value)}
                value={distributionType}
              >
                <Radio value="Platform">send emails & reminders</Radio>
                <Radio value="Manual">send manual link</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          {distributionType === "Platform" && (
            <Form.Item
              name="gdprConsent"
              valuePropName="checked"
              rules={[
                {
                  validator(_, value) {
                    if (!value) {
                      return Promise.reject("Please provide GDPR consent");
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Checkbox>I confirm GDPR consent for sending emails</Checkbox>
            </Form.Item>
          )}

          {distributionType === "Platform" && teamSize <= 12 && (
            <Form.List name="members">
              {(fields, { add, remove }) => (
                <>
                  <div className="add-team-men-mbers-main">
                    <h5>Team Members (Names & Emails)</h5>
                    <Row
                      gutter={[12, 12]}
                      align="middle"
                      style={{ marginBottom: 16 }}
                    >
                      <Col>
                        <Form.Item name="upload" noStyle>
                          <Upload
                            beforeUpload={(file) => {
                              const reader = new FileReader();
                              reader.onload = (e) => {
                                const data = new Uint8Array(e.target.result);
                                const workbook = XLSX.read(data, {
                                  type: "array",
                                });
                                const sheetName = workbook.SheetNames[0];
                                const sheet = workbook.Sheets[sheetName];
                                const json = XLSX.utils.sheet_to_json(sheet);

                                const members = json.map((row) => ({
                                  name: row.Name || "",
                                  email: row.Email || "",
                                }));

                                // Push members into form
                                form.setFieldsValue({
                                  members,
                                });
                              };
                              reader.readAsArrayBuffer(file);
                              return false; // prevent auto upload
                            }}
                            showUploadList={false}
                          >
                            <Button icon={<ArrowUpFromLine />}>
                              Upload Excel
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                      <Col>
                        <Button
                          icon={<PlusOutlined />}
                          onClick={() => add()}
                          type="primary"
                        >
                          Add Member
                        </Button>
                      </Col>
                    </Row>
                  </div>
                  {fields.map((field) => (
                    <Row
                      key={field.key}
                      gutter={[12, 12]}
                      style={{ marginBottom: 12 }}
                    >
                      <Col flex="auto">
                        <Form.Item
                          {...field}
                          name={[field.name, "name"]}
                          normalize={(val) => val.trimStart()}
                          noStyle
                        >
                          <Input placeholder="Member name" />
                        </Form.Item>
                      </Col>
                      <Col flex="auto">
                        <Form.Item
                          className="mb-0"
                          {...field}
                          name={[field.name, "email"]}
                          normalize={(val) => val.trimStart()}
                          rules={[
                            {
                              required: true,
                              message: "Please enter member email",
                            },
                            {
                              pattern:
                                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|org|net|info|xyz|online|tech|shop|app)$/i,
                              message:
                                "Enter a valid email (.com, .org, .net, .info, .xyz, .online, .tech, .shop, .app only)",
                            },
                            {
                              max: 100,
                              message: "Email cannot exceed 100 characters",
                            },
                          ]}
                        >
                          <Input placeholder="Member email" />
                        </Form.Item>
                      </Col>

                      <Col>
                        <Button
                          type="text"
                          onClick={() => remove(field.name)}
                          className="delete-button-binn"
                        >
                          <Trash2 />
                        </Button>
                      </Col>
                    </Row>
                  ))}
                </>
              )}
            </Form.List>
          )}

          {distributionType === "Manual" && teamSize <= 12 && (
            <Form.List name="members">
              {(fields, { add, remove }) => (
                <>
                  <div className="add-team-men-mbers-main">
                    <h5>Team Members (Name Only)</h5>
                    <Row
                      gutter={[12, 12]}
                      align="middle"
                      style={{ marginBottom: 16 }}
                    >
                      <Col>
                        <Button
                          icon={<PlusOutlined />}
                          onClick={() => add()}
                          type="primary"
                        >
                          Add Member
                        </Button>
                      </Col>
                    </Row>
                  </div>
                  {fields.map((field) => (
                    <Row
                      key={field.key}
                      gutter={[12, 12]}
                      align="middle"
                      style={{ marginBottom: 12 }}
                    >
                      <Col flex="auto">
                        <Form.Item
                          {...field}
                          name={[field.name, "name"]}
                          noStyle
                        >
                          <Input placeholder="Member name" />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Button
                          type="text"
                          onClick={() => remove(field.name)}
                          className="delete-button-binn"
                        >
                          <Trash2 />
                        </Button>
                      </Col>
                    </Row>
                  ))}
                </>
              )}
            </Form.List>
          )}

          {distributionType === "Platform" && teamSize > 12 && (
            <Form.List name="members">
              {(fields, { add, remove }) => (
                <>
                  <div className="add-team-men-mbers-main">
                    <h5>Team Members (Emails Only)</h5>
                    <Row
                      gutter={[12, 12]}
                      align="middle"
                      style={{ marginBottom: 16 }}
                    >
                      <Col>
                        <Button
                          icon={<PlusOutlined />}
                          onClick={() => add()}
                          type="primary"
                        >
                          Add Member
                        </Button>
                      </Col>
                    </Row>
                  </div>
                  {fields.map((field) => (
                    <Row
                      key={field.key}
                      gutter={[12, 12]}
                      align="middle"
                      style={{ marginBottom: 12 }}
                    >
                      <Col flex="auto">
                        <Form.Item
                          {...field}
                          name={[field.name, "email"]}
                          noStyle
                          rules={[
                            { required: true, message: "Enter email" },
                            { type: "email", message: "Invalid email" },
                          ]}
                        >
                          <Input placeholder="Member email" />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Button
                          type="text"
                          onClick={() => remove(field.name)}
                          className="delete-button-binn"
                        >
                          <Trash2 />
                        </Button>
                      </Col>
                    </Row>
                  ))}
                </>
              )}
            </Form.List>
          )}

          {/* Open-ended questions */}
          <h6 className="main-new-secong-header">
            Open-Ended Questions :
            <span style={{ fontSize: "12px", color: "#4D4D4D" }}>
              (Optional but strongly recommended)
            </span>
          </h6>

          <Form.Item name="question1" label="Question 1">
            <Input placeholder="Question 1 (optional)" />
          </Form.Item>
          <Form.Item name="question2" label="Question 2">
            <Input placeholder="Question 2 (optional)" />
          </Form.Item>
          <Form.Item name="question3" label="Question 3">
            <Input placeholder="Question 3 (optional)" />
          </Form.Item>
          <Form.Item name="question4" label="Question 4">
            <Input placeholder="Question 4 (optional)" />
          </Form.Item>

          <Form.Item
            name="deadline"
            label="Target Deadline"
            rules={[
              { required: true, message: "Please provide target deadline!" },
            ]}
          >
            <DatePicker
              disabledDate={(now) => now && now <= moment()}
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item name="draft" label="Email Template">
            <ReactQuill
              theme="snow"
              value={value}
              onChange={setValue}
              placeholder="Enter Email Template..."
              style={{ height: "250px", marginBottom: "40px" }}
            />
          </Form.Item>

          <div className="modal-footer-main">
            <Button disabled={loading} type="link" onClick={() => navigate(-1)}>
              Back
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Launch TPS Survey
            </Button>
          </div>
        </Form>
      </Card>

      {/* Success Modal */}
      <Modal
        open={isModalVisible}
        // onCancel={() => {
        //   setIsModalVisible(false)
        //   navigate("/tq-team-servey");
        // }}

        onCancel={handleModalCloseAndNavigate}
        footer={null}
        centered
        closable={false}
        width={540}
        bodyStyle={{ textAlign: "center", padding: 24 }}
      >
        <div className="members-modal-main members-modal-main-check">
          <div className="question-mark-image">
            {/* <img src={CheckBigImage} alt="Question Mark" /> */}
          </div>
          <h4>Invitation Sent Successfully!</h4>
          <h6>
            Your TPS survey has been sent to all team members via email. <br />
            You can also copy the Survey link below.
          </h6>
          <div className="cpoy-link-button" onClick={handleCopyLink}>
            {/* <img src={CopylinkImage} alt="copy" /> */}
            Copy Link
          </div>
          <div className="modal-footer-main">
            <Button onClick={handleModalCloseAndNavigate} type="link">
              Cancel
            </Button>
            <Button type="primary" onClick={handleDownloadLink}>
              {/* <img src={DownloadImage} alt="download" />  */}
              Download Link
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SetupSurveyForm;

const industries = [
  "Agriculture, Forestry, Mining and Fishing",
  "Construction and Real Estate",
  "Consulting Services",
  "Education and Research",
  "Finance and Insurance",
  "Healthcare and Life Sciences",
  "Information Technology and Telecommunications",
  "Manufacturing and Industrial Production",
  "Public Sector and Nonprofit",
  "Retail, Wholesale, and Consumer Goods",
  "Transportation, Logistics, and Travel",
  "Other",
];

const roles = [
  "Customer Service / Support",
  "Engineering / Technical",
  "Executive / General Management",
  "Finance / Accounting",
  "Human Resources (HR)",
  "Information Technology (IT) / Systems",
  "Legal / Compliance",
  "Marketing / Communications",
  "Operations / Supply Chain / Logistics",
  "Product Management",
  "Quality / Health & Safety",
  "Research & Development (R&D)",
  "Sales / Business Development",
  "Strategy / Corporate Development",
  "Other",
];
